import { render, staticRenderFns } from "./ActiveIngredientsMobileSelectorModal.vue?vue&type=template&id=4f499e3f&scoped=true"
import script from "./ActiveIngredientsMobileSelectorModal.vue?vue&type=script&lang=js"
export * from "./ActiveIngredientsMobileSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./ActiveIngredientsMobileSelectorModal.vue?vue&type=style&index=0&id=4f499e3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f499e3f",
  null
  
)

export default component.exports